import { Directive } from '@angular/core';

@Directive({
    selector: '[onFileSelect]'
})
export class OnFileSelectDirective {
    // Todo[Shubham] Need to implement 2 drag and drop file directives
}
